import { render, staticRenderFns } from "./SectionClientProfile.vue?vue&type=template&id=0133609e&scoped=true&"
import script from "./SectionClientProfile.vue?vue&type=script&lang=js&"
export * from "./SectionClientProfile.vue?vue&type=script&lang=js&"
import style0 from "./SectionClientProfile.vue?vue&type=style&index=0&id=0133609e&prod&lang=sass&scoped=true&"
import style1 from "./SectionClientProfile.vue?vue&type=style&index=1&id=0133609e&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0133609e",
  null
  
)

export default component.exports